import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
  faTrashAlt,
  faMinusSquare,
} from '@fortawesome/free-solid-svg-icons';
import Amplify from 'aws-amplify';
import CONFIGS from './configs';
import './styles/clinicards.scss';
import './assets/locale/i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';

require('moment/locale/nl.js');

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://4080a5f9fb1b4cec88551472cdf22e83@sentry.io/1380987',
  });
}

const { AWS } = CONFIGS;
Amplify.configure({
  ...AWS,
});

library.add([faSpinner, faTrashAlt, faMinusSquare]);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
